var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.787 121.046C114.787 121.938 113.749 122.797 111.863 123.574C105.657 126.167 90.1526 128.001 72.0109 128.001C61.2333 128.001 51.3867 127.357 43.8675 126.283C42.6381 126.101 41.4566 125.92 40.3585 125.721C33.436 124.482 29.2109 122.847 29.2109 121.046C29.2109 119.527 32.1828 118.139 37.2315 116.999C40.4301 116.272 44.4762 115.661 49.1429 115.182C51.3748 114.951 53.7499 114.753 56.2325 114.604C58.1182 114.472 60.0637 114.389 62.0688 114.307C64.8497 114.191 67.7142 114.125 70.6861 114.125H71.9751C78.7424 114.125 85.1397 114.373 90.8329 114.835C91.6564 114.901 92.4919 114.967 93.2796 115.05C93.7928 115.1 94.318 115.149 94.8431 115.199C99.5098 115.678 103.556 116.289 106.778 117.016C111.815 118.156 114.775 119.56 114.775 121.063",
    fill: "#14181C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.133 68.5468C128.133 98.9922 103.453 123.672 73.0078 123.672C42.5624 123.672 17.8828 98.9922 17.8828 68.5468C17.8828 38.1015 42.5624 13.4219 73.0078 13.4219C103.453 13.4219 128.133 38.1015 128.133 68.5468Z",
    fill: "#229F64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0635 104.29L37.0859 82.1026L46.1884 73.4986L58.2875 86.2981L102.394 41.9062L111.278 50.7342L58.0691 104.296L58.0635 104.29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.c7379d5007ef44a9ef1be059795464ce.svg";
export { ForwardRef as ReactComponent };